<template>
  <div>
    <v-row
      class="primary create-filter-header"
      elevation="4">
      <code class="ma-2 white create-filter-header-title pt-1">
        <h2>Filter | กรุณาเลือกรายการที่ต้องการ</h2>
      </code>
      <v-spacer />
      <v-btn
        color="warning"
        class="ma-2"
        @click="$router.push({ name: 'FilteredList' })">
        ปิด
      </v-btn>
    </v-row>
    <v-row justify="space-around">
      <v-sheet
        width="100%"
        elevation="4"
        class="py-10 px-6">
        <ValidationObserver
          ref="obs"
          tag="form"
          @submit.prevent="onSubmit()">
          <v-col
            v-for="(unUse, index) in forms"
            :key="index"
            cols="12">
            <v-divider
              v-if="index !== 0"
              class="pb-3" />
            <div class="pb-5 d-flex">
              <div
                v-if="index !== 0"
                class="ml-4"
                style="width: 150px;">
                <v-select
                  v-model="conditions[index-1]"
                  :items="additionalOptions"
                  dense />
              </div>
              <v-spacer />
              <div>
                <v-btn
                  v-if="index !== 0"
                  icon
                  @click="deleteForm(index)">
                  <v-icon color="error">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <Renderer
              v-for="(element, name) in schema"
              :key="name"
              v-model="forms[index][name]"
              :element="element"
              @input="processedTrigger(index, name, $event)"
              @disable-trigger="disableTrigger(index, name, $event)" />
          </v-col>
          <v-col>
            <v-row justify="center">
              <v-col class="text-right">
                <h4 class="pt-2">
                  เพิ่มเงื่อนไข
                </h4>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="conditionSelected"
                  :items="additionalOptions"
                  dense />
              </v-col>
              <v-col>
                <v-btn
                  color="warning"
                  @click="addForm()">
                  เพิ่ม
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row>
              <v-col>
                <v-divider class="pb-3" />
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col
                cols="2"
                class="text-right">
                <h4 class="pt-2">
                  ชื่อการค้นหา
                </h4>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="formsName"
                  solo
                  style="height: 60px" />
              </v-col>
              <v-col cols="2"></v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  type="reset"
                  color="error"
                  @click="onReset()">
                  ล้างค่า
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-btn
                  type="submit"
                  color="primary">
                  ค้นหา
                </v-btn>
              </v-col>
              <v-col></v-col>
            </v-row>
          </v-col>
        </ValidationObserver>
        <v-col>
        </v-col>
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import SchemaController from '@/utils/schemaController'
import FiltersProvider from '@/resources/FiltersProvider'
import Renderer from '@/components/form/Renderer'

const filtersService = new FiltersProvider()

export default {
  components: {
    Renderer
  },
  data () {
    return {
      formsName: '',
      forms: [{}],
      processedForm: [{}],
      conditions: [],
      conditionSelected: 'INTERSECT',
      additionalOptions: [
        { text: 'Intersec', value: 'INTERSECT' },
        { text: 'Union', value: 'UNION' },
        { text: 'Difference', value: 'COMPLEMENT' }
      ]
    }
  },
  computed: {
    schema () {
      return SchemaController.schema
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    async onSubmit () {
      const validate = await this.selfValidate()
      if (validate.type === 'success') {
        try {
          const res = await filtersService.createFilter({
            name: this.formsName,
            options: this.processedForm,
            operators: this.conditions
          })
          if (res.message === 'done') {
            validate.message = 'การค้นหาใช้เวลาประมาณ 30 วินาที ถึง 2 นาที กรุณารีเฟรชอีกภายหลัง'
            validate.type = 'success'
          } else {
            validate.message = 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่ภายหลัง'
            validate.type = 'error'
          }
        } catch (e) {
          console.error(e)
          validate.message = 'เซิฟเวอร์เกิดข้อผิดพลาด กรุณาลองใหม่'
          validate.type = 'error'
        } finally {
          this.setSnackBar({
            value: true,
            message: validate.message,
            type: validate.type
          })

          if (validate.type === 'success') {
            this.$router.push({ name: 'FilteredList' })
          }
        }
      } else {
        this.setSnackBar({
          value: true,
          message: validate.message,
          type: validate.type
        })
      }
    },
    async selfValidate () {
      let message = ''
      let type = ''

      if (JSON.stringify(this.processedForm) === '[{}]') {
        message = 'กรุณากรอกฟอร์ม'
        type = 'warning'
      } else if (this.formsName === '') {
        message = 'กรุณากรอกชื่อฟอร์ม'
        type = 'warning'
      } else {
        const isValid = await this.$refs.obs.validate()
        if (isValid) {
          message = 'ฟอร์มถูกต้อง'
          type = 'success'
        } else {
          message = 'กรอกฟอร์มไม่ถูกต้อง'
          type = 'error'
        }
      }

      return { message, type }
    },
    onReset () {
      this.$refs.obs.reset()
      this.forms = [{}]
      this.processedForm = [{}]
    },
    processedTrigger (index, name, val) {
      this.processedForm[index][name] = val
    },
    disableTrigger (index, name, enable) {
      if (!enable) {
        delete this.processedForm[index][name]
      } else {
        this.processedForm[index][name] = this.forms[index][name]
      }
    },
    addForm () {
      this.forms.push({})
      this.processedForm.push({})
      this.conditions.push(this.conditionSelected)
    },
    deleteForm (index) {
      this.setModal({
        value: true,
        title: 'ลบฟอร์ม',
        confirmText: 'ลบ',
        cancelText: 'ยกเลิก',
        message: 'คุณต้องการจะลบฟอร์มหรือไม่?',
        confirmOnly: false,
        onConfirm: () => {
          this.forms.splice(index, 1)
          this.processedForm.splice(index, 1)
          this.conditions.splice(index - 1, 1)
          this.setModal({ value: false })
        }
      })
    }
  }
}

</script>

<style>
.in-component .v-input--is-disabled.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  background-color: #dadada;
}
.close-btn {
  position: absolute;
}

.create-filter-header {
  height: 50px;
}

.create-filter-header-title {
  border-radius: 10px;
  color: black !important;
}
</style>
